/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApiAddOrUpdateMpmPriceItem } from './apiAddOrUpdateMpmPriceItem';


export interface ApiAddOrUpdateMpmPricesRequest { 
    mtms: Array<ApiAddOrUpdateMpmPriceItem>;
    productId: string;
    currencyId: string;
    mtmDate: string;
}

